module.exports = __webpack_public_path__ + "img/table.f24b192c.png";